// 自動延長の発火予定（= expireAt - 通知分）までの残り時間を算出する。
// 発火は終了予定の1分前（バックエンド Table::AUTO_EXTENSION_NOTICE_MINUTES と一致。終了通知設定とは独立）。
export const AUTO_EXTENSION_NOTICE_MINUTES = 1

// 予告カウントダウンを表示し始める発火予定までのリード時間（分）。
// これより前は表示しない（ON/OFFはトグルで常時操作可能なので停止手段は失われない）。
export const NOTICE_LEAD_MINUTES = 10

const fireAtMs = (expireAt, noticeMinutes) => {
  const minutes = Number(noticeMinutes) > 0 ? Number(noticeMinutes) : AUTO_EXTENSION_NOTICE_MINUTES

  return Date.parse(expireAt) - minutes * 60000
}

// 発火予定までの残り分数（切り上げ）
export const minutesUntilAutoExtension = (expireAt, noticeMinutes, now = new Date()) => {
  if (!expireAt) return null

  return Math.ceil((fireAtMs(expireAt, noticeMinutes) - now.getTime()) / 60000)
}

// 発火予定までの残り秒数（切り上げ）。1分未満の予告を秒で出すのに使う。
export const secondsUntilAutoExtension = (expireAt, noticeMinutes, now = new Date()) => {
  if (!expireAt) return null

  return Math.ceil((fireAtMs(expireAt, noticeMinutes) - now.getTime()) / 1000)
}

// 終了予定(expireAt)の変化が自動延長の発火によるものか。
// 自動延長は発火予定(= 旧expireAt - notice分)の時刻に起きるため、
// その時刻を過ぎたタイミングでの変化なら自動延長とみなす。
// 手動延長/時間編集(まだ発火予定前)は false になり、「自動延長中…」と誤表示しない。
export const isAutoExtensionFire = (oldExpireAt, now = new Date(), noticeMinutes = AUTO_EXTENSION_NOTICE_MINUTES) => {
  if (!oldExpireAt) return false

  return now.getTime() >= fireAtMs(oldExpireAt, noticeMinutes)
}

export default () => ({
  minutesUntilAutoExtension,
  secondsUntilAutoExtension,
})
